import { FirebaseCollection } from './firebase';
import { collection, query, where, getDocs, limit, doc, setDoc } from "firebase/firestore";
import db from "../api/firebase";

export const getPlayerByActivationCode = async (code: string) : Promise<IPlayer> => {

    const collectionRef = collection(db, FirebaseCollection.Players);
    const q = query(collectionRef, where("activationCode", "==", code), limit(1));

    const data = await getDocs(q);
    // console.log("getPlayerByActivationCode", data.docs[0].id);

    let player = data.docs[0]?.data() as IPlayer;
    player.id = data.docs[0]?.id;
    return player;
}

export const activatePlayer = async (player: IPlayer) : Promise<boolean> => {

    const docRef = doc(db, FirebaseCollection.Players, player.id);
    player.activationDate = new Date();

    try{
        await setDoc(docRef, player);
        return true;
    } catch (error) {
        console.log("activatePlayer error", error);
        return false;
    }
}

export interface IPlayer {
    id: string;
    activationCode: string;
    activationDate: Date | null;
    email: string;
    female: boolean;
    name: string;
    schoolClass: string;
    score: number
}